Vue.component('ExcelsiorActivityCards', () => import('./ActivityCards'))
Vue.component('ExcelsiorCategoriesGraph', () => import('./CategoriesGraph'))